export default "__VITE_ASSET__SZJpTH7i__"